import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

export default function UsersAdmin() {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState(['admin', 'editor', 'viewer']);

  const fetchUsers = async () => {
    try {
      const res = await axios.get('/api/admin/users');
      setUsers(res.data);
    } catch (err) {
      toast.error("Erreur lors du chargement des utilisateurs");
    }
  };

  const updateRole = async (id, role) => {
    try {
      await axios.put(`/api/admin/users/${id}`, { role });
      toast.success("Rôle mis à jour");
      fetchUsers();
    } catch (err) {
      toast.error("Erreur lors de la mise à jour");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Gestion des Utilisateurs</h2>
      <table className="w-full border rounded">
        <thead>
          <tr className="bg-gray-100 dark:bg-gray-800">
            <th className="p-2">Email</th>
            <th className="p-2">Rôle</th>
            <th className="p-2">Changer le rôle</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id} className="border-t">
              <td className="p-2">{user.email}</td>
              <td className="p-2 font-medium">{user.role}</td>
              <td className="p-2">
                <select
                  className="p-2 border rounded"
                  value={user.role}
                  onChange={(e) => updateRole(user.id, e.target.value)}
                >
                  {roles.map(role => (
                    <option key={role} value={role}>{role}</option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}